<template>
  <section class="banner">
    <div class="banner__wrapper">
      <div class="banner__inner">
        <div class="banner__text">
          <h1 class="animation-item animation-top">Innowacyjna archiwizacja</h1>
          <p class="animation-item animation-item--duration1 animation-top">
            Nowy wymiar archiwizacji wraz z obsługą
            <br /> materialno - cyfrową Twoich danych
          </p>
        </div>
        <div class="banner__button animation-item animation-item--duration2 animation-top">
          <ciaButton
            :color="'white'"
            :click="goToLogin"
            :big="true">ZACZNIJ TERAZ</ciaButton>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ciaButton from './../../components/LandingPage/button.vue';

export default {
  name: 'top-banner',
  components: {
    ciaButton,
  },
  methods: {
    goToLogin() {
      this.$router.push('/login');
    },
  },
};
</script>

<style lang="scss" scoped>
  .banner {
    background: url('./../../assets/banner-bcg.png') 50% 100% no-repeat;
    background-size: cover;
    @media (min-width: 550px) {
      padding-bottom: 208px;
    }
    width: 100%;
    /*height: 1060px;*/
    &__wrapper {
      padding: 50px 0;
      display: flex;
      align-items: center;
      height: calc(100vh - 115px);
      max-height: 50vh;
      min-height: 400px;
      @media (min-width: 550px) {
        min-height: 550px;
      }
      @media (min-width: 1000px) {
        max-height: 851px;
      }
    }
    &__button {
      padding-top: 30px;
      @media (min-width: 1000px) {
        padding-top: 50px;
      }
    }
    &__inner {
      text-align: center;
      max-width: 700px;
      margin: 0 auto;
      color: #fff;
      transform: translate(0, -50px);
      @media (min-width: 550px) {
        transform: none;
      }
      h1 {
        font-weight: 500;
        font-size: 20px;
        padding-bottom: 20px;
        @media (min-width: 550px) {
          font-size: 30px;
        }
        @media (min-width: 1000px) {
          font-size: 44px;
          padding-bottom: 40px;
        }
      }
      p {
        font-weight: 300;
        font-size: 14px;
        @media (min-width: 550px) {
          font-size: 18px;
        }
        @media (min-width: 1000px) {
          font-size: 21px;
        }
      }
    }
  }
</style>
